import * as React from "react";
import {cx} from "emotion";

import "./template-selection-template-view.scss";

import {cs}          from "@Common/react/chain-services";
import {scopedState} from "@Common/react/scoped-state";
import {UseState}    from "@Common/react/use-state";
import {Responsive}  from "@Common/ui-components/responsive";

import {BackTemplateSelector} from "./back-template-selector/back-template-selector";
import {FrontTemplateViewer}  from "./front-template-viewer/front-template-viewer";

export const TemplateSelectionTemplateView = ({allowReproof, loadingProofs, templateBack, state, next}) => cs(
    ["frontBackState", (_, next) => UseState({
        initValue: {mode: "front"},
        next,
    })],
    ["frontTemplateViewer", (_, next) => FrontTemplateViewer({
        images: state.value?.itemThumbnails?.length > 0 ? state.value?.itemThumbnails : templateBack?.images?.map(({url}) => url),
        loading: !!loadingProofs.value,
        state,
        templateBacks: templateBack?.backs,
        next,
    })],
    ["backTemplateState", (_, next) => next( scopedState(state, ["sku", "back"]))],
    ["backTemplateSelector", ({backTemplateState}, next) => (
        templateBack?.backs?.length > 0 && (!(state.value?.itemThumbnails?.length > 0) || state.value?.changeBackOverride)
    ) ? (
        BackTemplateSelector({
            allowReproof,
            isFromApproval: false,
            item: undefined,
            loadingProofs,
            selected: backTemplateState,
            state,
            templateBacks: templateBack.backs,
            next
        })
    ) : (
        next()
    )],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ({backTemplateSelector, frontTemplateViewer, responsive, frontBackState}) => next({
        render: () => (
            <div className="template-selection-template-view template-selection-template-view-k99">
                {responsive.lt("mobile") ? (
                    <>
                        {backTemplateSelector && (
                            <div className="tabs">
                                <div
                                    onClick={() => frontBackState.onChange({mode: "front"})}
                                    className={cx("tab", {"selected": frontBackState.value.mode == "front"})}
                                    xd-qa-type="Button"
                                    xd-qa-name="Front"
                                >
                                    Front
                                </div>
                                <div
                                    onClick={() => frontBackState.onChange({mode: "back"})}
                                    className={cx("tab", {"selected": frontBackState.value.mode == "back"})}
                                    xd-qa-type="Button"
                                    xd-qa-name="Back"
                                >
                                    Back
                                </div>
                            </div>
                        )}
                        {frontBackState.value.mode == "front" ? frontTemplateViewer?.render() : backTemplateSelector?.render()}
                    </>
                ) : (<>
                    <div className="side-by-side">
                        {frontTemplateViewer?.render()}
                        {backTemplateSelector?.render()}
                    </div>
                    <div className="footer">
                        <div className="right">
                            <div className="enlarge"
                                xd-qa-type="button" xd-qa-name="Click to Enlarge">
                                <i className="fa fa-search"/>
                                <div className="text">
                                    {templateBack?.backs?.length > 0 ? "Click on each preview to enlarge" : "Click to Enlarge"}
                                </div>
                            </div>
                        </div>
                    </div>
                </>)}
            </div>
        )
    }),
);
